// extracted by mini-css-extract-plugin
export var list = "news-module--list--1OrCG";
export var jsAnimInit = "news-module--jsAnimInit--2_QZM";